import { Utils } from "helpers/utils";
import React from "react";

interface WpTagBadgeProps {
  keyId: any;
  tagId: number;
  foreColor: string | null;
  backColor: string | null;
  faIcon: string | null;
  tagName: string;
  onClickTag?: (tagId: number) => void;
  suffixIcon?: string | null;
  onSuffixClick?: (tagId: number) => void;
}
const WpTagBadge = ({ keyId, tagId, foreColor, backColor, faIcon, tagName, onClickTag, suffixIcon, onSuffixClick }: WpTagBadgeProps) => {
  const onclickTagIn = async (tagId: number) => {
    if (onClickTag) {
      onClickTag(tagId);
    } else {
      Utils.ShowWpTagInfo(tagId);
    }
  }

  return (
    <span key={keyId}
      className="wp-tag-filter hand hover"

    // style={{ color: foreColor ?? "white", backgroundColor: backColor ?? "black" }}
    >
      <span onClick={() => onclickTagIn(tagId)}>
        <span className={faIcon ?? "fas fa-at"}></span>&nbsp;{tagName}
      </span>
      {suffixIcon && (
        <i className={"ms-1 " + suffixIcon} onClick={(e) => onSuffixClick?.(tagId)}></i>
      )}
    </span>
  );
};

export default WpTagBadge;
